<template>
  <div>
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters();"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- Searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              :disable="!hideFilters || activeFilters"
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString('module.spare-parts.list.filter.label')"
            />
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="!hideFilters" class="table-block q-mb-md">
        <div class="row q-pa-md" style="justify-content: space-between;">
          <div class="col-6 q-pa-md">
            <q-input color="primary"
              v-model="filters.reference"
              @input="applyFilters"
              :float-label="getString(null, 'Reference', 'Referentie')"/>
          </div>
          <div class="col-6 q-pa-md">
            <q-input color="primary"
              v-model="filters.batch_number"
              @input="applyFilters"
              :float-label="getString(null, 'Batch Number', 'Batchnummer')"/>
          </div>
        </div>
        <div class="row q-pa-md" style="justify-content: space-between;">
          <div class="col-6 q-pa-md">
            <q-toggle
              v-model="filters.with_update"
              :true-value="1"
              :false-value="null"
              :color="checkboxActive"
              @input="applyFilters"
              :label="getString(null, 'Has Updates', 'Heeft updates')"
              />
          </div>
        </div>
        <div class="row q-pa-md" style="justify-content: space-between">
          <div class="q-pa-md" style="vertical-align: middle">
            <q-btn
              :disable="!activeFilters"
              @click="resetFilters()"
              class="capitalize ctrl-button"
              :color="activeFilters ? 'primary' : 'grey-4'"
              label="Reset"
            />
          </div>
        </div>
      </div>
    </transition>

    <table-overview
      endpoint="spareparts"
      :responseFormat="'references'"
      :columns="columns"
      permission="spare-parts"
      module="spare-parts"
      :selectable="false"
      :custom-events="true"
      @click="onRowClicked"
    >
    </table-overview>
  </div>
</template>

<script>
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

// Components
import TableOverview from '@/components/overview/TableOverview.vue';

export default {
  mixins: [filtersMixin],
  components: {
    TableOverview,
  },
  data() {
    return {
      isLoading: false,
      module: 'spare-parts',
      permission: 'spareparts',
      columns: [
        {
          name: '__slot:spareparts-reference',
          title: getString('module.spare-parts.field.serviceReference'),
          sortField: 'references',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
          callback: 'getPdfName',
        },
        {
          name: 'external_id',
          title: getString(null, 'External ID', 'Externe ID'),
          sortField: 'references',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
        },
        {
          name: 'batch_number',
          title: getString(null, 'Batch Number', 'Batchnummer'),
          sortField: 'batch_number',
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-m user text-ellipsis',
        },
        {
          name: 'is_delivered',
          title: 'Delivered',
          sortField: 'activated',
          titleClass: 'text-left sortable vcol-sm',
          dataClass: 'text-left vcol-sm text-ellipsis',
          callback: 'isDelivered',
        },
        {
          name: '__slot:spareparts-activated',
          title: 'Activated',
          sortField: 'activated',
          titleClass: 'text-left sortable vcol-sm',
          dataClass: 'text-left vcol-sm text-ellipsis',
        },
      ],
      filters: {
        reference: '',
        batch_number: '',
        with_update: false,
      },
      searchTerm: '',
      hideFilters: true,
    };
  },
  methods: {
    getString,
    onRowClicked(data) {
      if (
        this.$store.state.meStore.me.rights.includes(
          `${this.permission}.edit`,
        )
        || this.$store.state.meStore.me.su
      ) {
        this.$router.push(`/${this.module}/${data.row.id}`);
      }
    },
    notify(message, actions = []) {
      this.$q.notify({
        message,
        position: 'top-right',
        timeout: 6000,
        color: 'warning',
        actions,
      });
    },
  },
  computed: {
    checkboxActive() {
      return this.filters.active ? 'primary' : 'grey-4';
    },
  },
};
</script>

<style lang="stylus">
@import '~variables';

.pdf-status {
  display: flex;

  &__indicate {
    margin: 0 5px;
    width: 20px;
    min-width: 20px;
    height: 20px;
    background-color: $ctrl-grey-lighten-1;
    border-radius: 50%;
    display: block;

    &--green {
      background-color: $ctrl-turquoise;
    }

    &--red {
      background-color: $ctrl-red;
    }

    &--blue {
      background-color: $ctrl-blue;
    }
  }
}
</style>
